"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Ref, Mixins } from "vue-property-decorator";
import { ApplicationItemModel } from "@/models/Applications.model";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import BlockDialog from "@/components/layout/components/dialog/BlockDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
let ApplicationItem = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.webSocketService = WebsocketViewService;
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.logout.refresh",
        (data) => __async(this, null, function* () {
          location.reload();
        })
      );
    });
  }
  openNotice() {
    return __async(this, null, function* () {
      var _a;
      if ((_a = this.$session) == null ? void 0 : _a.marks.is("KV_INTERNAL_USER")) {
      } else {
        this._block_dialog.open();
      }
    });
  }
  goMyApp() {
    this.$router.push("/myapp");
  }
  goApp() {
    this.$router.push("/app");
  }
  jump(url, isNew = false) {
    return __async(this, null, function* () {
      if (url === "" || url === null || url === void 0) {
        return;
      }
      if (isNew) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    });
  }
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  PropSync("appItem", { type: ApplicationItemModel })
], ApplicationItem.prototype, "_item", 2);
__decorateClass([
  Ref("blockDialog")
], ApplicationItem.prototype, "_block_dialog", 2);
ApplicationItem = __decorateClass([
  Component({
    components: {
      BlockDialog
    }
  })
], ApplicationItem);
export {
  ApplicationItem as default
};
